// hooks/useGroceries.js - REVISADO
import { useState, useCallback } from 'react';
import { groceriesApi } from '../api/groceriesApi';
import { transformItemData } from '../utils/itemUtils';

export const useGroceries = (showToast) => {
  const [allItems, setAllItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      const data = await groceriesApi.fetchList();
      
      const transformedData = data.map(transformItemData);
      
      setAllItems(transformedData);
      setError(null);
      return transformedData;
    } catch (err) {
      setError(`Error loading items: ${err.message}`);
      if (showToast) showToast(`Error loading items: ${err.message}`, 'error');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  const addNewItem = useCallback(async (itemData, showToastFn = showToast) => {
    try {
      const result = await groceriesApi.insertItem(itemData);
      if (!result.success) throw new Error(result.message || 'Error adding item');
      
      const newItem = transformItemData(result.data);
      
      // ACTUALIZACIÓN OPTIMISTA: No necesitamos recargar todo
      setAllItems(prev => [...prev, newItem]);
      
      if (showToastFn) showToastFn('Item added successfully', 'success');
      return newItem;
    } catch (err) {
      if (showToastFn) showToastFn(`Error adding item: ${err.message}`, 'error');
      throw err;
    }
  }, [showToast]);

  const updateItem = useCallback(async (itemData, showToastFn = showToast) => {
    try {
      const result = await groceriesApi.editItem(itemData);
      if (!result.success) throw new Error(result.message || 'Error updating item');
      
      const updatedItem = transformItemData(result.data);
      
      // ACTUALIZACIÓN OPTIMISTA: Solo actualizamos ese item
      setAllItems(prev => prev.map(item => 
        item.id === result.data.id ? updatedItem : item
      ));
      
      if (showToastFn) showToastFn('Item updated successfully', 'success');
      return updatedItem;
    } catch (err) {
      if (showToastFn) showToastFn(`Error updating item: ${err.message}`, 'error');
      throw err;
    }
  }, [showToast]);

  const deleteItem = useCallback(async (id, showToastFn = showToast) => {
    try {
      const result = await groceriesApi.deleteItem(id);
      if (!result.success) throw new Error(result.message || 'Error deleting item');
      
      // ACTUALIZACIÓN OPTIMISTA: Solo removemos ese item
      setAllItems(prev => prev.filter(item => item.id !== id));
      
      return true;
    } catch (err) {
      if (showToastFn) showToastFn(`Error deleting item: ${err.message}`, 'error');
      throw err;
    }
  }, [showToast]);

  return {
    allItems,
    setAllItems,
    loading,
    error,
    fetchItems,
    addNewItem,
    updateItem,
    deleteItem
  };
};